import { cn } from '@virginexperiencedays/tailwind';
import type { Image as ProductImage } from '@virginexperiencedays/products';

import { Carousel } from '../../../layout/Carousel';
import { Image } from '../../../layout/Image';
import { YoutubeEmbed } from '../../../layout/YoutubeEmbed';

import { assignContentType } from './assignContentType';

type Props = {
  images: ProductImage[];
  className?: string;
  productName?: string;
};

export const HeroCarousel = ({ images, className, productName }: Props) => {
  return (
    <Carousel
      className={cn(
        '[&_>_.track]:m-0 [&_>_.track]:scroll-p-0 [&_>_.track]:p-0 [&_>_.track_&:first-child]:mx-0 md:[&_>_.track_&:not(:first-child)]:hidden [&_>_.track_>_*]:w-full',
        className
      )}
      withHeading={false}
      showPageIndicators
      perPage={{
        mobile: 'full',
      }}
    >
      {images.map((element, index) => {
        return carouselElementsFactory(element, index, productName);
      })}
    </Carousel>
  );
};

export const carouselElementsFactory = (
  image: ProductImage,
  index: number,
  productName?: string
) => {
  const { type, url, altText } = assignContentType(image) ?? {};

  switch (type) {
    case 'yt':
      return <YoutubeEmbed key={index} url={url} withSwipeFunctionality />;
    case 'img':
      return (
        <Image
          key={index}
          className={index === 0 ? 'hero-images-static-image-image' : ''}
          dataTestId={
            index === 0 ? 'hero-images-static-image-image' : 'hero-images-mobile-carousel-image'
          }
          src={url}
          priority={index === 0}
          alt={altText ?? productName ?? ''}
          width={1200}
          height={800}
          quality={50}
        />
      );
    default:
      return null;
  }
};
